import TRANSLATION_ACCESSIBILITY_RO from './accessibility/translation';
import TRANSLATION_BOOKING_RO from './booking/translation';
import TRANSLATION_EVENTS_RO from './events/translation';
import TRANSLATION_EXPERIENCES_RO from './experiences/translation';
import TRANSLATION_FORM_RO from './form/translation';
import TRANSLATION_LANDING_PAGES_RO from './landingPages/translation';
import TRANSLATION_RESERVE_RO from './reserve/translation';
import TRANSLATION_SIGNIN_RO from './signin/translation';
import TRANSLATION_DATES_RO from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_RO,
  ...TRANSLATION_BOOKING_RO,
  ...TRANSLATION_DATES_RO,
  ...TRANSLATION_EVENTS_RO,
  ...TRANSLATION_EXPERIENCES_RO,
  ...TRANSLATION_FORM_RO,
  ...TRANSLATION_LANDING_PAGES_RO,
  ...TRANSLATION_RESERVE_RO,
  ...TRANSLATION_SIGNIN_RO,
};
